module.exports = __webpack_public_path__ + "img/275.8051b492.png";